import React from "react";
import { Grid, Collapse, Typography } from '@material-ui/core'
import { classExpression } from "@babel/types";
import { makeStyles } from "@material-ui/styles";
import { generalFormStyles } from './StyleObjects/generalStyles';
import { colors } from '../helpers/styles/colors'
import { ReactIcon } from '../icons/ReactIcon';
import { TypescriptIcon } from '../icons/TypescriptIcon';
import { JavaScriptIcon } from '../icons/JavaScriptIcon';
import { LinkedInIcon } from '../icons/LinkedInIcon';
import { EmailIcon } from '../icons/EmailIcon';
import { GitHubIcon } from '../icons/GitHubIcon';

import { IconLink } from '../components/IconLink';

const useFormStyles = makeStyles(generalFormStyles);

export default function About() {
    const classes = useFormStyles();
    return (
        <div className={classes.formSectionMargin}>
            <h1 className={classes.heading}>
                Hello, I am Namrata Ajmeri
            </h1>
            <p className={classes.subInformation}>
                I am a full-stack developer. <br />
                <span className={classes.skillsHighlight}>My skillset ranges from design (Html + CSS) to JavaScript <JavaScriptIcon /> + TypeScript <TypescriptIcon /> + ReactJS <ReactIcon /> ,
                    all the way to C#, Java, SQL.</span>
            </p>
        </div>
    );
}